// src/pages/BinStockDetail.js
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SimilarProductsSlider from "./SimilarProducts";
import RecentViewedSlider from "./RecentView";
import { AddToCart } from "../../api/cartService";
import { toast } from "react-toastify";

// Mock API function
const fetchProductDetail = async (productId) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            const products = {
                1: {
                    productId: 1, name: "Starshine Ring", productCode: "PT65001", purity: "18k Gold / Rose", goldWeight: "2.80 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.32 ct", diamondQuality: "VVS1", price: 22000,
                    images: [
                        "/assets/images/binstock/Ring1.png",
                    ],
                    category: "Rings",
                    stockQuantity: 12
                },
                2: {
                    productId: 2, name: "Aurora Ring", productCode: "PT65002", purity: "18k Gold / Rose", goldWeight: "3.20 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.45 ct", diamondQuality: "VS1", price: 25000,
                    images: [
                        "/assets/images/binstock/Ring2.png",
                    ],
                    category: "Rings",
                    stockQuantity: 15
                },
                3: {
                    productId: 3, name: "Effulgent Ring", productCode: "PT65003", purity: "18k Gold / Rose", goldWeight: "3.05 Gms approx", diamondType: "Marquise & Princess Cut Diamond", diamondWeight: "0.52 ct", diamondQuality: "VVS1", price: 28000,
                    images: [
                        "/assets/images/binstock/Ring3.png",
                    ],
                    category: "Rings",
                    stockQuantity: 10
                },
                4: {
                    productId: 4, name: "Nimbus Ring", productCode: "PT65004", purity: "18k Gold / Rose", goldWeight: "2.65 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.28 ct", diamondQuality: "VS2", price: 21000,
                    images: [
                        "/assets/images/binstock/Ring4.png",
                    ],
                    category: "Rings",
                    stockQuantity: 18
                },
                5: {
                    productId: 5, name: "Moonlit Ring", productCode: "PT65005", purity: "18k Gold / Rose", goldWeight: "3.10 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.40 ct", diamondQuality: "VVS2", price: 24500,
                    images: [
                        "/assets/images/binstock/Ring5.png",
                    ],
                    category: "Rings",
                    stockQuantity: 9
                },
                6: {
                    productId: 6, name: "Celest Ring", productCode: "PT65006", purity: "18k Gold / Rose", goldWeight: "2.95 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.38 ct", diamondQuality: "VS1", price: 23500,
                    images: [
                        "/assets/images/binstock/Ring6.png",
                    ],
                    category: "Rings",
                    stockQuantity: 20
                },
                7: {
                    productId: 7, name: "Skyward Ring", productCode: "PT65007", purity: "18k Gold / Rose", goldWeight: "3.30 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.47 ct", diamondQuality: "VVS1", price: 26000,
                    images: [
                        "/assets/images/binstock/Ring7.png",
                        "/assets/images/binstock/Ring7-1.png"
                    ],
                    category: "Rings",
                    stockQuantity: 14
                },
                8: {
                    productId: 8, name: "Sacred Stud Earring", productCode: "PT65008", purity: "18k Gold / Rose", goldWeight: "2.20 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.30 ct", diamondQuality: "VS1", price: 18000,
                    images: [
                        "/assets/images/binstock/Ring8.png",
                    ],
                    category: "Earrings",
                    stockQuantity: 16
                },
                9: {
                    productId: 9, name: "Pinnacle Stud Earring", productCode: "PT65009", purity: "18k Gold / Rose", goldWeight: "2.15 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.28 ct", diamondQuality: "VVS2", price: 17500,
                    images: [
                        "/assets/images/binstock/Ring9.png",
                    ],
                    category: "Earrings",
                    stockQuantity: 22
                },
                10: {
                    productId: 10, name: "Clarity Stud Earring", productCode: "PT65010", purity: "18k Gold / Rose", goldWeight: "2.05 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.26 ct", diamondQuality: "VS1", price: 17000,
                    images: [
                        "/assets/images/binstock/Ring10.png",
                    ],
                    category: "Earrings",
                    stockQuantity: 19
                },
                11: {
                    productId: 11, name: "Gaze Stud Earring", productCode: "PT65011", purity: "18k Gold / Rose", goldWeight: "2.30 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.33 ct", diamondQuality: "VVS1", price: 18500,
                    images: [
                        "/assets/images/binstock/Ring11.png",
                    ],
                    category: "Earrings",
                    stockQuantity: 13
                },
                12: {
                    productId: 12, name: "Crown Stud Earring", productCode: "PT65012", purity: "18k Gold / Rose", goldWeight: "2.40 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.35 ct", diamondQuality: "VS2", price: 19000,
                    images: [
                        "/assets/images/binstock/Ring12.png",
                    ],
                    category: "Earrings",
                    stockQuantity: 17
                },
                13: {
                    productId: 13, name: "Divine Stud Earring", productCode: "PT65013", purity: "18k Gold / Rose", goldWeight: "2.28 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.34 ct", diamondQuality: "VS1", price: 18200,
                    images: [
                        "/assets/images/binstock/Ring13.png",
                    ],
                    category: "Earrings",
                    stockQuantity: 21
                },
                14: {
                    productId: 14, name: "Linara Stud Earring", productCode: "PT65014", purity: "18k Gold / Rose", goldWeight: "2.18 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.29 ct", diamondQuality: "VVS2", price: 17800,
                    images: [
                        "/assets/images/binstock/Ring14.png",
                    ],
                    category: "Earrings",
                    stockQuantity: 23
                },
                15: {
                    productId: 15, name: "Oren Stud Earring", productCode: "PT65015", purity: "18k Gold / Rose", goldWeight: "2.25 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.31 ct", diamondQuality: "VS1", price: 17900,
                    images: [
                        "/assets/images/binstock/Ring15.png",
                    ],
                    category: "Earrings",
                    stockQuantity: 20
                },
                16: {
                    productId: 16, name: "Zest Stud Earring", productCode: "PT65016", purity: "18k Gold / Rose", goldWeight: "2.12 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.27 ct", diamondQuality: "VS2", price: 16800,
                    images: [
                        "/assets/images/binstock/Ring16.png",
                    ],
                    category: "Earrings",
                    stockQuantity: 26
                },
                17: {
                    productId: 17, name: "Bold Ring", productCode: "PT65017", purity: "18k Gold / Rose", goldWeight: "3.45 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.50 ct", diamondQuality: "VVS1", price: 29000,
                    images: [
                        "/assets/images/binstock/Ring17.png",
                    ],
                    category: "Rings",
                    stockQuantity: 11
                },
                18: {
                    productId: 18, name: "Velvet Ring", productCode: "PT65018", purity: "18k Gold / Rose", goldWeight: "3.25 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.44 ct", diamondQuality: "VS1", price: 25500,
                    images: [
                        "/assets/images/binstock/Ring18.png",
                    ],
                    category: "Rings",
                    stockQuantity: 16
                },
                19: {
                    productId: 19, name: "Glimmer Ring", productCode: "PT65019", purity: "18k Gold / Rose", goldWeight: "3.18 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.42 ct", diamondQuality: "VVS2", price: 24800,
                    images: [
                        "/assets/images/binstock/Ring19.png",
                    ],
                    category: "Rings",
                    stockQuantity: 13
                },
                20: {
                    productId: 20, name: "Jewel Ring", productCode: "PT65020", purity: "18k Gold / Rose", goldWeight: "3.05 Gms approx", diamondType: "Round Brilliant Diamond", diamondWeight: "0.39 ct", diamondQuality: "VS1", price: 24000,
                    images: [
                        "/assets/images/binstock/Ring20.png",
                    ],
                    category: "Rings",
                    stockQuantity: 18
                },
            };

            resolve(products[productId] || null);
        }, 500);
    });
};

export default function BinStockDetail() {
    const { productId } = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedImage, setSelectedImage] = useState(0);

    useEffect(() => {
        document.title = product ? `${product.name} - Bin Stock` : "Product Details";
    }, [product]);

    useEffect(() => {
        const loadProductDetail = async () => {
            try {
                setLoading(true);
                const productData = await fetchProductDetail(parseInt(productId));

                if (productData) {
                    setProduct(productData);
                    addToRecentViews(productData); 
                } else {
                    setError("Product not found");
                }
            } catch (err) {
                console.error("Error fetching product details:", err);
                setError("Failed to load product details");
            } finally {
                setLoading(false);
            }
        };

        if (productId) {
            loadProductDetail();
        }
    }, [productId]);

    const handleAddToCart = async () => {
        if (!product) return;
        try {
            const payload = {
                Style_ID: String(product.productId),
                Quantity: "1",
                Remark: `Added from bin stock: ${product.name}`,
            };

            const response = await AddToCart(payload);
            console.log("AddToCart API Response:", response);

            if (response?.success || response?.status || !response?.error) {
                toast.success("Product added to cart!", { theme: "colored" });
            } else {
                throw new Error(response?.message || "Failed to add to cart");
            }

        } catch (error) {
            console.error("AddToCart Error in Detail Page:", error);
            toast.error("Failed to add product to cart");
        }
    };

    const addToRecentViews = (product) => {
        let recent = JSON.parse(localStorage.getItem("recentViews")) || [];

        recent = recent.filter(p => p.id !== product.productId);
        recent.unshift(product);
        recent = recent.slice(0, 8);

        localStorage.setItem("recentViews", JSON.stringify(recent));
    };

    useEffect(() => {
        fetchProductDetail(productId).then((res) => {
            setProduct(res);
            addToRecentViews(res);
        });
    }, [productId]);

    const goBack = () => {
        navigate(-1);
    };

    if (loading) {
        return (
            <section className="d-flex align-items-center justify-content-center">
                <div className="text-center">
                    <div className="spinner-border text-primary mb-3" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="text-muted">Loading product details...</p>
                </div>
            </section>
        );
    }

    if (error || !product) {
        return (
            <section className="d-flex align-items-center justify-content-center">
                <div className="text-center">
                    <h2 className="text-danger mb-3">Product Not Found</h2>
                    <p className="text-muted mb-4">{error || "The product you're looking for doesn't exist."}</p>
                    <button onClick={goBack} className="btn btn-primary">
                        Go Back to Bin Stock
                    </button>
                </div>
            </section>
        );
    }

    return (
        <section className="py-4">
            <ToastContainer position="top-right" autoClose={3000} theme="colored" />

            <div className="container">
                {/* Breadcrumb */}
                <div className="mb-4">
                    <button onClick={goBack} className="btn btn-outline-primary btn-sm">
                        <i className="bx bx-arrow-back me-2"></i>
                        Back to Bin Stock
                    </button>
                </div>

                <div className="row g-4">
                    {/* Product Images */}
                    <div className="col-lg-6">
                        <div className="card border-0 bg-white shadow-none">
                            <div className="card-body p-3">
                                <div className="row g-3 m-0">
                                    {Array.from({ length: 4 }).map((_, index) => (
                                        <div className="col-12 col-lg-6 col-md-6 mt-2 pe-0" key={index}>
                                            <div
                                                className="border p-2 border-1"
                                                style={{
                                                    cursor: "pointer",
                                                    height: "320px",
                                                    transition: "all 0.3s ease",
                                                }}
                                                onClick={() => setSelectedImage(index)}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = "scale(1.01)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = "scale(1)";
                                                }}
                                            >
                                                <img
                                                    src={product.images[index] || "/assets/images/binstock/no-image.jpg"}
                                                    alt={`${product.name} view ${index + 1}`}
                                                    className="img-fluid w-100 h-100 rounded"
                                                    style={{ objectFit: "cover" }}
                                                    onError={(e) => {
                                                        e.target.onerror = null; // prevent infinite loop
                                                        e.target.src = "/assets/images/binstock/no-image.jpg";
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Product Info */}
                    <div className="col-lg-6">
                        <div className="card bg-white shadow-none border-0 h-100">
                            <div className="card-body bg-white">
                                {/* Product Title and Code */}
                                <h1 className="h3 fw-bold text-dark mb-2">{product.name}</h1>
                                <p className="fw-bold mb-3">
                                    <strong>Product Code:</strong> {product.productCode}
                                </p>

                                {/* Price */}
                                <div className="mb-4">
                                    <h3 className="h4 text-primary fw-bold">₹{product.price?.toLocaleString()}</h3>
                                </div>

                                {/* Product Details */}
                                <div className="mb-4">
                                    <h5 className="fw-bold text-dark mb-3">Product Details:</h5>
                                    <div className="row g-2">
                                        <div className="col-sm-12">
                                            <div className="d-flex justify-content-start pb-1">
                                                <span className="fw-bold me-3">Purity:</span>
                                                <span className="fw-medium">{product.purity}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-12">
                                            <div className="d-flex justify-content-start pb-1">
                                                <span className="fw-bold me-3">Gold Wt:</span>
                                                <span className="fw-medium">{product.goldWeight}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-12">
                                            <div className="d-flex justify-content-start pb-1">
                                                <span className="fw-bold me-3">Product Dimensions:</span>
                                                <span className="fw-medium">{product.dimensions}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-12">
                                            <div className="d-flex justify-content-start pb-1">
                                                <span className="fw-bold me-3">Chain Length:</span>
                                                <span className="fw-medium">{product.chainLength}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Diamond Details */}
                                <div className="mb-4">
                                    <h5 className="fw-bold text-dark mb-3">Diamond Details:</h5>
                                    <div className="row g-2">
                                        <div className="col-sm-12">
                                            <div className="d-flex justify-content-start pb-1">
                                                <span className="fw-bold me-3">Diamond Type:</span>
                                                <span className="fw-medium">{product.diamondType}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-12">
                                            <div className="d-flex justify-content-start pb-1">
                                                <span className="fw-bold me-3">Diamond Weight:</span>
                                                <span className="fw-medium">{product.diamondWeight}</span>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="d-flex justify-content-start pb-1">
                                                <span className="fw-bold me-3">Diamond Quality:</span>
                                                <span className="fw-medium">{product.diamondQuality}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                

                                
                               
                                <div className="d-flex gap-3">
                                    <button
                                        type="button"
                                        className="btn-animate"
                                        onClick={() => console.log("Enquire Now Clicked")}
                                    >
                                        <span>ENQUIRE NOW</span>
                                        <i className="bx bx-chevrons-right fs-3"></i>
                                    </button>

                                    <button
                                        type="button"
                                        className="btn-animate"
                                        onClick={handleAddToCart}
                                    >
                                        <span>ADD TO CART</span>
                                        <i className="bx bx-chevrons-right fs-3"></i>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {product && (
                    <SimilarProductsSlider
                        currentProductId={parseInt(productId)}
                        category={product.category}
                    />
                )}

                <RecentViewedSlider />


            </div>
        </section>
    );
}